//////// EF 1.5 Schema
const oneFiveSchema = {
  title: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
  cat: "1_5",
  catName: "cat1",
  progressiveOrderSwitch: {
    by: { level: 2, key: "sourceEFName" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 2,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "1_1",
      },
      showIf: { level: 1, key: "emissionFactorTypeId", ne: "2" },
      combineKey: 1,
    },
    ////////Emission Source / Sink Category
    {
      key: "sinkCategory",
      level: 3,
      type: "select",
      label: "Emission Source / Sink Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "sourceEFName",
      },
      showIf: {
        level: 2,
        key: "sourceEFName",
        notEmpty: true,
      },
      combineKey: 2,
    },
    ////////Region and Condition
    {
      key: "regionAndCondition",
      level: 4,
      type: "select",
      label: "Region and Condition",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "sinkCategory",
      },
      showIf: {
        level: 3,
        key: "sinkCategory",
        notEmpty: true,
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 5,
      type: "select",
      label: "Ecosystem Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "regionAndCondition",
      },
      showIf: {
        level: 4,
        key: "regionAndCondition",
        notEmpty: true,
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 5,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum:0,
    },
  ],
};

export default oneFiveSchema;